var _rect, _rect2, _rect3, _ellipse, _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyField(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.691615,
    y: 19.2917,
    width: 23.3861,
    height: 33.1405,
    rx: 3.5,
    transform: "rotate(-32.9846 0.691615 19.2917)",
    fill: "white",
    stroke: "#E1E3E5",
    strokeDasharray: "4 2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.679043,
    y: 0.197233,
    width: 23.3861,
    height: 33.1405,
    rx: 3.5,
    transform: "matrix(-0.876276 -0.481809 -0.481809 0.876276 62.821 17.1425)",
    fill: "white",
    stroke: "#E1E3E5",
    strokeDasharray: "4 2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19.9707,
    y: 0.5,
    width: 25.8392,
    height: 36.5749,
    rx: 3.5,
    fill: "white",
    stroke: "#E1E3E5",
    strokeDasharray: "4 2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9983,
    cy: 54.8674,
    rx: 17.0667,
    ry: 1.06667,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1797 8.05469L37.5734 17.4484",
    stroke: "#E1E3E5",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5762 8.05469L28.1824 17.4484",
    stroke: "#E1E3E5",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2996_118785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.709 36.768L48.484 37.5433L49.39 38.4446L49.7391 38.7962L51.5469 36.9872L49.5199 34.957L47.709 36.768Z",
    fill: "#C1C4C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3901 36.9766L59.6286 43.2147C60.0979 43.6827 60.3891 44.3324 60.3872 45.0468C60.3872 45.7626 60.0978 46.4116 59.6286 46.8815C59.1606 47.3489 58.5125 47.6372 57.7968 47.6372C57.0814 47.6372 56.434 47.3489 55.9647 46.8799L49.7266 40.6411L53.3901 36.9766Z",
    fill: "#D4D4D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5293 37.8399L53.0362 37.332L59.2753 43.5711C59.6692 43.9653 59.8858 44.4896 59.8855 45.0477C59.8855 45.6072 59.6682 46.1325 59.2753 46.5273C59.2036 46.5962 59.1117 46.6309 59.0211 46.6309C58.9285 46.6309 58.8373 46.5962 58.766 46.5264C58.6271 46.3856 58.6271 46.1601 58.766 46.0204C59.0262 45.7612 59.1684 45.414 59.1684 45.0467C59.1693 44.681 59.0263 44.3364 58.7679 44.0784L52.5293 37.8399Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7262 40.6424L53.3901 36.9776L53.1168 36.7036C52.9519 36.5381 52.7264 36.4375 52.4757 36.4375C52.2234 36.4375 51.9973 36.5377 51.834 36.7024L49.4514 39.0862C49.2877 39.2486 49.1855 39.4748 49.1855 39.7274C49.1855 39.9762 49.2875 40.2051 49.4514 40.3666L49.7262 40.6424Z",
    fill: "#BEBEC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8516 27.8142C28.8516 21.3465 34.0959 16.1016 40.5649 16.1016C47.0345 16.1016 52.2785 21.3468 52.2785 27.8142C52.2785 34.2838 47.0339 39.5278 40.5649 39.5294C34.0959 39.5278 28.8516 34.2837 28.8516 27.8142Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5647 38.2615C46.3321 38.2615 51.01 33.5854 51.01 27.8154C51.01 22.0487 46.3322 17.3711 40.5647 17.3711C34.7965 17.3712 30.1191 22.0485 30.1191 27.8155C30.1191 33.5854 34.7965 38.2615 40.5647 38.2615Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5646 37.4257C45.8707 37.4257 50.1736 33.1245 50.1736 27.8157C50.1736 22.5109 45.8705 18.207 40.5646 18.207C35.2586 18.207 30.9551 22.5109 30.9551 27.8157C30.9551 33.1242 35.2575 37.4257 40.5646 37.4257Z",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8173 19.7848C40.6536 19.542 40.3723 19.39 40.0628 19.4076C38.7363 19.4882 37.4828 19.8618 36.3373 20.5269C35.9339 20.7628 35.7956 21.2826 36.0306 21.6878C36.2655 22.088 36.786 22.2304 37.1881 21.9923C38.1019 21.4652 39.102 21.1657 40.1623 21.1011C40.6281 21.0768 40.9864 20.6751 40.9575 20.2096C40.9521 20.0483 40.898 19.9032 40.8173 19.7848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3766 22.5698C35.3315 22.5022 35.2727 22.4394 35.2082 22.386C34.8444 22.0884 34.311 22.1463 34.0169 22.5098C33.1513 23.5725 32.5555 24.8476 32.2925 26.2045C31.9814 27.8162 32.1442 29.4663 32.7621 30.9783C32.9422 31.4142 33.4379 31.6188 33.8703 31.4406C34.3039 31.265 34.5105 30.7711 34.333 30.3353C33.8402 29.1295 33.7123 27.8127 33.9626 26.5264C34.1673 25.4431 34.6431 24.4261 35.3336 23.5779C35.5737 23.2826 35.58 22.8683 35.3766 22.5698Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2996_118785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.5361,
    height: 31.5361,
    fill: "white",
    transform: "translate(28.8516 16.1016)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyField);
export default __webpack_public_path__ + "static/media/emptyField.a949c5efa1da4764c9642e9ad65e973c.svg";
export { ForwardRef as ReactComponent };